export const GET_APPS = "GET_APPS";
export const GET_APP_BY_ID = "GET_APP_BY_ID";
export const UPDATE_APP = "UPDATE_APP";
export const DELETE_APP = "DELETE_APP";
export const CREATE_APP = "CREATE_APP";
